import { render, staticRenderFns } from "./CardsList.vue?vue&type=template&id=62f76ff2&scoped=true"
import script from "./CardsList.vue?vue&type=script&lang=js"
export * from "./CardsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f76ff2",
  null
  
)

export default component.exports